function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGoldenWeekFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.852 20.768c1.277 0 2.355-.451 3.213-1.342v-3.5h-3.277v1.542h1.681v1.122c-.373.406-.944.638-1.604.638-1.354 0-2.334-1.254-2.334-2.96 0-1.694.925-2.97 2.135-2.97.814 0 1.486.506 1.893 1.398l1.408-.826c-.705-1.342-1.893-2.112-3.29-2.112-2.19 0-3.905 1.99-3.905 4.522 0 2.618 1.694 4.488 4.08 4.488zm6.886-2.3l-1.231-6.534h-1.815l1.969 8.658h2.156l1.287-5.457 1.265 5.457h2.157l1.969-8.658H23.68l-1.233 6.535-1.452-6.535H19.18l-1.442 6.535zM16 4C9.383 4 4 9.383 4 16s5.383 12 12 12 12-5.383 12-12S22.617 4 16 4zm0 26C8.28 30 2 23.72 2 16S8.28 2 16 2s14 6.28 14 14-6.28 14-14 14z",
    fill: props.color
  }));
}

export default SvgIconGoldenWeekFilled;